import { render, staticRenderFns } from "./create_grv.vue?vue&type=template&id=15b8c30d&scoped=true"
import script from "./create_grv.vue?vue&type=script&lang=js"
export * from "./create_grv.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b8c30d",
  null
  
)

export default component.exports